/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OorRemovalResponseDto
 */
export interface OorRemovalResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof OorRemovalResponseDto
     */
    workflowInstanceId?: string;
    /**
     * Workflow task actor id that is used for this operation
     * @type {string}
     * @memberof OorRemovalResponseDto
     */
    workflowInstanceAssignedTaskId?: string;
    /**
     * 
     * @type {string}
     * @memberof OorRemovalResponseDto
     */
    requesterId?: string;
}

/**
 * Check if a given object implements the OorRemovalResponseDto interface.
 */
export function instanceOfOorRemovalResponseDto(value: object): boolean {
    return true;
}

export function OorRemovalResponseDtoFromJSON(json: any): OorRemovalResponseDto {
    return OorRemovalResponseDtoFromJSONTyped(json, false);
}

export function OorRemovalResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OorRemovalResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'workflowInstanceAssignedTaskId': json['workflowInstanceAssignedTaskId'] == null ? undefined : json['workflowInstanceAssignedTaskId'],
        'requesterId': json['requesterId'] == null ? undefined : json['requesterId'],
    };
}

export function OorRemovalResponseDtoToJSON(value?: OorRemovalResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'workflowInstanceAssignedTaskId': value['workflowInstanceAssignedTaskId'],
        'requesterId': value['requesterId'],
    };
}

